import React from 'react';

const Reviews = () => {
  return (
    <div className='bg-[#ecf1fc]'>
      <div className='w-full py-10 xl:px-[10%] lg:px-[8%] xs:px-[5%] md:px-[6%] sm:px-[5%]  px-6  pt-10'>
        {/* Main Review */}
        <div className='rounded-2xl mb-6 bg-white p-8  xs:p-6 shadow-2xl'>
          <h1 className='text-[25px] xs:text-[16px] md:p-10 sm:p-10 lg:p-10 font-inter font-medium text-center'>
          I used to wake up after nights out with so many cringe-worthy texts sent to my ex. Thanks to DrunkMates, I’ve saved myself so much embarrassment—and probably a few friendships too!"          </h1>
          <div className='flex justify-center'>
            <span className='flex flex-col items-center gap-2 pt-4'>
              <img
                src="https://appblock.app/wp-content/uploads/2024/04/Mariana-64x64-c-center.webp"
                alt="Marianna"
                className='rounded-full w-16 h-16'
              />
              <p className='font-inter font-medium'> Samantha R., London</p>
              <p className='font-inter text-[#777] font-medium'>
                on 9 to 5 with theSkimm podcast
              </p>
            </span>
          </div>
        </div>

        {/* Grid of Reviews */}
        <div className='grid xs:grid-cols-1 sm:grid-cols-2 grid-cols-3 gap-6'>
          {/* Review 1 */}
          <div className='bg-white rounded-2xl xs:p-6  p-10 flex flex-col justify-between  shadow-md'>
            <p className='font-inter text-[20px] xs:text-[16px] text-center mb-4'>
            DrunkMates is a genius idea! It’s like having a responsible best friend in your pocket. No more drunk tweets or accidental calls to my boss. Highly recommend!"            </p>
            <div className='flex flex-col items-center pt-4'>
              <p className='font-inter text-[17px] font-semibold'>Shavy Jaine</p>
              <p className='font-inter text-[17px] text-[#777] font-semibold'>
                direct message on LinkedIn
              </p>
            </div>
          </div>

          {/* Review 2 */}
          <div className='bg-white rounded-2xl  xs:p-6  p-10 flex flex-col justify-between  shadow-md'>
            <p className='font-inter text-[20px] xs:text-[16px] text-center mb-4'>
I love how easy it is to set up. Now I can enjoy my nights without worrying about my phone betraying me. Waking up without regret feels so good!            </p>
            <div className='flex flex-col items-center pt-4'>
              <p className='font-inter text-[17px] font-semibold'>Jokha Al Zakwani</p>
              <p className='font-inter text-[17px] text-[#777] font-semibold'>
                5 star review on Google Play
              </p>
            </div>
          </div>

          {/* Review 3 */}
          <div className='bg-white rounded-2xl  xs:p-6  p-10 flex flex-col justify-between  shadow-md'>
            <p className='font-inter text-[20px] xs:text-[16px] text-center mb-4'>
              Really amazing app to help eliminate distractions for people living w/ADHD, as we’re especially vulnerable to technology addiction & the dopamine-inducing tactics of Big Tech.
            </p>
            <div className='flex flex-col items-center pt-4'>
              <p className='font-inter text-[17px] font-semibold'>J.J.</p>
              <p className='font-inter text-[17px] text-[#777] font-semibold'>
                5 star review on AppStore
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;



// import React from 'react'

// const Reviews = () => {
//   return (
//     <div className='bg-[#ecf1fc]'>
  
//     <div className='w-full  px-[5%]  xs:px-[2%] pt-10  '>
//         <div className=' rounded-2xl mb-6 bg-white xs:p-4  p-20 shadow-2xl'>
// <h1 className='text-[25px] xs:text-[16px] font-inter xs:p-0  font-medium text-center'> “I think we have a habit of opening phone and tap on Instagram because you’re waiting for the elevator or you’re waiting for coffee and it’s natural thing to do. So AppBlock is help me a lot.”</h1>
// <div className='flex justify-center'>
// <span className='flex flex-col items-center gap-2 justify-center pt-4'>
//     <p>    <img src="https://appblock.app/wp-content/uploads/2024/04/Mariana-64x64-c-center.webp" alt="" /></p>
//     <p className='font-inter font-medium'> Marianna Hewitt </p>
//     <p className='font-inter text-[#777] font-medium'>on 9 to 5 with theSkimm podcast</p>

// </span>
// </div>


//         </div>
//         <div className='w-full flex xs:flex-col  xs:gap-4  gap-10 justify-between pb-10'>

    
//         <div className='bg-white rounded-2xl flex flex-col xs:max-h-full min-h-[420px] xs:justify-normal justify-between xs:py-4 xs:w-full w-[33%] px-8 py-10'>
// <p className='flex font-inter xs:text-[16px] text-[20px] text-center '>AppBlock has quite literally changed my life! I have: Regained my focus, Built a workout routine, Read 13 books in 3 months, Reached new career milestones, Ditched the dopamine 1st routine. All thanks to the gift of this app, and its iron-clad Strict Mode.</p>

// <p className='flex justify-start  items-center flex-col xs:pt-6 '>
//     <p className='font-inter text-[17px] font-semibold'> Shavy Jaine </p>
//     <p className='font-inter text-[17px] text-[#777] font-semibold'>direct message on LinkedIn</p>
// </p>
//         </div>
//         <div className='bg-white rounded-2xl flex flex-col  justify-between xs:max-h-full min-h-[420px] xs:justify-normal xs:py-4 xs:w-full w-[33%] px-8 py-10 '>
// <p className='flex font-inter xs:text-[16px] text-[20px] text-center '>Really helps me study and stay active I love this app Whoever is seeing my message install the app now its very useful for me to stay active Bye 😁</p>

// <p className='flex justify-start items-center flex-col xs:pt-6 '>
//     <p className='font-inter text-[17px] font-semibold'> Jokha Al Zakwani  </p>
//     <p className='font-inter text-[17px] text-[#777] font-semibold'>5 star review on Google Play</p>
// </p>
//         </div>
//         <div className='bg-white rounded-2xl flex flex-col  xs:max-h-full min-h-[420px] xs:justify-normal justify-between xs:py-4 xs:w-full w-[33%] px-8 py-10 '>
// <p className='flex font-inter xs:text-[16px] text-[20px] text-center '>Really amazing app to help eliminate distractions for people living w/ADHD, as we’re especially vulnerable to technology addiction & the dopamine-inducing tactics of Big Tech.</p>

// <p className='flex justify-start items-center flex-col xs:pt-6'>
//     <p className='font-inter text-[17px] font-semibold'>  J.J.  </p>
//     <p className='font-inter text-[17px] text-[#777] font-semibold'>5 star review on AppStore</p>
// </p>
//         </div>

//         </div>

//     </div>
//     </div>
//   )
// }

// export default Reviews